import { Card, Radio } from "antd";
import { useState } from "react";

interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateMultipleCho({
  data,
  viewOnly = false,
}: Props) {
  const [value, setValue] = useState<number | string>(data?.answer);

  return (
    <>
      <Card className="mt-4">
        <div className=" justify-start text-zinc-700 text-base font-medium">
          {data?.question_title}
        </div>
        <div className="mt-4">
          <Radio.Group
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
            onChange={(e) =>
              data?.answer || viewOnly
                ? setValue(data?.answer || "")
                : setValue(e.target.value)
            }
            value={data?.answer || value}
            options={
              data?.question_choices?.map((choice: any) => ({
                value: choice,
                label: choice,
              })) || []
            }
          />
        </div>
      </Card>
    </>
  );
}
